export default {
  slug: "67-minutes-for-mandela-day",
  title: "67 Minutes for Mandela Day",
  date: "2026-08-06",
  author: "About U",
  cover: "/images/blog/mandela-day.webp",
  coverAlt: "The AboutU team handing over a voucher at the George Golf Club",
  body: `
At AboutU Financial Advisors, we believe that growth starts with investing in the future.

Following the devastating storms that resulted in the loss of many trees across George, we used our 67 Minutes for Mandela Day to donate a voucher from George Botanical Nursery to the George Golf Club to support their tree replanting initiative.

Here’s to new growth - for our environment, our community, and the generations to come.
`,
};
